module.exports = __webpack_public_path__ + "img/thunfischkaviarsushiflambiertfrontal.c6672cbd.png";